export const BASE_URL = "https://api.hotelmarinagrand.in/";
//export const BASE_URL = "http://localhost:3000/";

export const STATUS_CODE = {
  INTERNAL_SERVER_ERROR: 500,
  SUCCESS: 200,
};